jQuery(document).on({
	mouseenter: function () {
		jQuery(this).find('.haf-secondary').stop().animate({ opacity: 1 }, 350);
	},
	mouseleave: function () {
		jQuery(this).find('.haf-secondary').stop().animate({ opacity: 0 }, 350);
	}
}, '.haf-item');
